import { createFileRoute } from "@tanstack/react-router";

import { AccountSecurityBanner } from "@/components/account/account-security-banner";
import { ProviderCalendarContent } from "@/components/account/provider/profile/provider-calendar-content";

interface CalendarSearch {
  /** Deep-link target from push notifications — auto-opens the matching appointment sheet. */
  appointment?: string;
}

export const Route = createFileRoute("/_authenticated/account/provider/calendar")({
  validateSearch: (search: Record<string, unknown>): CalendarSearch => {
    const appointment = typeof search.appointment === "string" ? search.appointment : undefined;
    return appointment ? { appointment } : {};
  },
  component: ProviderCalendarPage,
});

function ProviderCalendarPage() {
  return (
    <>
      <ProviderCalendarContent />
      <AccountSecurityBanner />
    </>
  );
}
